import bookIcon from "./book.js";
import alertIcon from "./alert.js";
import checkIcon from "./check.js";
import targetIcon from "./target.js";
import redoIcon from "./redo.js";
import clockIcon from "./clock.js";
import calendarIcon from "./calendar.js";
import starsIcon from "./stars.js";
import scaffoldIcon from "./scaffold.svg";
import skillsIcon from "./skills.png";
import english from './english.jpg'
import spanish from './spanish.jpg'

export default {
  bookIcon,
  alertIcon,
  checkIcon,
  targetIcon,
  redoIcon,
  calendarIcon,
  clockIcon,
  starsIcon,
  scaffoldIcon,
  skillsIcon,
  english,
  spanish,
};
